var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-component"},[_c('b-card',{staticClass:"mb-2",style:({
      width: _vm.width,
      'border-radius': _vm.borderRadius,
    }),attrs:{"title":_vm.title},scopedSlots:_vm._u([(_vm.hasHeaderSlot)?{key:"header",fn:function(){return [_vm._t("header")]},proxy:true}:null],null,true)},[(_vm.loading)?_c('SpinnerLoader',{attrs:{"width":"3rem","height":"3rem","justify-content":"center"}}):[_c('b-card-text',[_vm._t("cardText")],2),_vm._t("default")]],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }